export const INVESTMENTS_MIX_PROPORTION_TABLE_EQUITY_HOLDINGS_COLOR = '#16A104';
export const INVESTMENTS_MIX_PROPORTION_TABLE_BOND_HOLDINGS_COLOR = '#096702';
export const INVESTMENTS_MIX_PROPORTION_TABLE_CASH_COLOR = '#004100';
